import React from "react";
import { Button, Form } from 'react-bootstrap';




const Reset = () => {

    return (
            <div className="forget-password-section">
                <div className="forget-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="forget-form">
                                    <h1>Reset your <span>Password</span></h1>
                                    <p>Enter your new password</p>
                                    <div className="forget-box">
                                        <Form>
                                            <Form.Group controlId="formBasicloginone">
                                                <Form.Label>Password</Form.Label>
                                                <Form.Control type="password" placeholder="Email Password" name="password"  />                                                
                                            </Form.Group>
                                            <Form.Group controlId="formBasicloginone">
                                                <Form.Label>Confirm Password</Form.Label>
                                                <Form.Control type="password" placeholder="Confirm Password" name="password"  />                                                
                                            </Form.Group>
                                            <div className="login-button">
                                            <Button type="submit" className="l-btn">
                                                Change Password
                                            </Button>
                                        </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Reset;